import styles from "./ProgressSteps.module.css";

export type StepNumber = 1 | 2 | 3;

const STEPS: { number: StepNumber; label: string }[] = [
  { number: 1, label: "Datum" },
  { number: 2, label: "Gegevens" },
  { number: 3, label: "Verzonden" },
];

export function ProgressSteps({ currentStep }: { currentStep: StepNumber }) {
  return (
    <nav aria-label="Voortgang van je aanvraag" className={styles.nav}>
      <ol className={styles.list}>
        {STEPS.map((step) => {
          const isCompleted = step.number < currentStep;
          const isCurrent = step.number === currentStep;
          return (
            <li
              key={step.number}
              className={styles.item}
              aria-current={isCurrent ? "step" : undefined}
            >
              <span
                className={[
                  styles.badge,
                  isCurrent ? styles.badgeCurrent : "",
                  isCompleted ? styles.badgeCompleted : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
                aria-hidden="true"
              >
                {isCompleted ? "✓" : String(step.number).padStart(2, "0")}
              </span>
              <span className={styles.label}>
                {String(step.number).padStart(2, "0")} {step.label}
                {isCompleted ? <span className="dmm-visually-hidden"> (voltooid)</span> : null}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
